import { motion } from 'framer-motion';
import { MessageCircle, X } from 'lucide-react';

/**
 * FloatingChatButton - A floating button that toggles the chatbot
 */
function FloatingChatButton({ isOpen, onClick }) {
  return (
    <motion.button
      onClick={onClick}
      className={`fixed bottom-6 right-6 z-50 rounded-full p-4 shadow-lg transition-colors ${
        isOpen ? 'bg-gray-700 hover:bg-gray-800' : 'bg-blue-600 hover:bg-blue-700'
      } text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ type: 'spring', stiffness: 260, damping: 20 }}
      aria-label={isOpen ? 'Close chat' : 'Open chat'}
    >
      {isOpen ? (
        <X className="h-6 w-6" />
      ) : (
        <MessageCircle className="h-6 w-6" />
      )}
    </motion.button>
  );
}

export default FloatingChatButton;

